import { User } from 'src/app/user/model/user';
import { CustomFile } from 'src/app/message/model/custom-file';

export class Message
{
    public id: number;
    public subject: string;
    public from: string;
    public fromId: number;
    public fromUsername: string;
    public fromPhotoUrl: string;
    public to: User[];
    public body: string;
    public sentOn: Date;
    public caseName: string;
    public caseId: number;
    public channelId: number;
    public channelName: string;
    public status: string;
    public memberId: number;
    public files: CustomFile[];
    public toAddresses: string;
    public fromDirectAddress: string;
}
